import { Stack, StackProps, Typography, TypographyProps } from "@mui/material";
import ButtonWithPermissions, { ButtonWithPermissionsProps } from "components/buttons/ButtonWithPermissions";
import { ReactNode } from "react";

interface PageHeaderProps {
  containerProps?: StackProps;
  title: ReactNode;
  subTitle?: ReactNode;
  titleProps?: TypographyProps;
  mainButtonProps?: ButtonWithPermissionsProps;
  CustomButtons?: ReactNode;
}

const PageHeader = ({
  containerProps,
  title,
  subTitle,
  titleProps,
  mainButtonProps,
  CustomButtons,
}: PageHeaderProps) => {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      alignItems={{ xs: "flex-start", md: "center" }}
      justifyContent='space-between'
      spacing={2}
      sx={{ mb: 2.5 }}
      {...containerProps}>
      <Stack spacing={0.5}>
        <Typography
          variant='h28'
          {...titleProps}>
          {title}
        </Typography>
        {!!subTitle && <Typography color='text.secondary'>{subTitle}</Typography>}
      </Stack>
      <Stack
        direction='row'
        spacing={1.5}>
        {!!CustomButtons && CustomButtons}
        {!!mainButtonProps && <ButtonWithPermissions {...mainButtonProps} />}
      </Stack>
    </Stack>
  );
};

export default PageHeader;
